const { ValidationError } = require('@plastiq/external-api-errors')

const BaseValidator = require('./BaseValidator')
const { CREDIT_CARD_DEFAULT } = require('./constants')
const { isValidCreditCard } = require('./helpers')

class LuhnValidator {
  static validate(argument, argumentName, options = CREDIT_CARD_DEFAULT) {
    BaseValidator.guardAgainstNullOrUndefined(argument, argumentName)
    const { minLength, maxLength, format } = options
    BaseValidator.validateLength(argument, argumentName, minLength, maxLength)
    validateLuhnFormat(argument, argumentName, format)
  }
}

function validateLuhnFormat(argument, argumentName, format) {
  if (format === CREDIT_CARD_DEFAULT.format) {
    if (!isValidCreditCard(argument)) {
      throw new ValidationError(`Invalid credit card format: ${argumentName}`)
    }
    return
  }
}

module.exports = LuhnValidator
